module.exports = __webpack_public_path__ + "img/pic3.83a01fd1.png";